
import Header from "../components/header";
import Footer from "../components/footer";

import banner01 from "../assets/images/architectural-consideration/architectural-consideration-1.webp"
import banner02 from "../assets/images/architectural-consideration/architectural-consideration-2.webp"
import banner03 from "../assets/images/architectural-consideration/architectural-consideration-3.webp"
import banner04 from "../assets/images/architectural-consideration/architectural-consideration-4.webp"
import banner05 from "../assets/images/architectural-consideration/architectural-consideration-5.webp"
import banner06 from "../assets/images/architectural-consideration/architectural-consideration-6.webp"
import banner07 from "../assets/images/architectural-consideration/architectural-consideration-7.webp"
import banner08 from "../assets/images/architectural-consideration/architectural-consideration-8.webp"
import banner09 from "../assets/images/architectural-consideration/architectural-consideration-9.webp"

const items =[
    {
title:"Rooted in Local Materials",
id:'elements39ffdyf1',
Sub:"Structures are built primarily with earth, stone, and other regionally sourced materials, reducing embodied energy and transport while supporting local craft economies. Stabilised mud blocks, rammed earth, and lime based systems create thermally comfortable, low-impact buildings that age gracefully with the landscape.",
banners:[
      banner01,
      banner02,
      banner03
]
},
{
title:"Integrated with Water and Ecology",
id:'elements39ffdyf2',
Sub:"Architecture and water systems are conceived together: roofs, courtyards, and pathways work with rainwater harvesting, groundwater recharge, and ecological wastewater treatment. Landscapes are layered to support biodiversity, retaining existing trees wherever possible and creating niches for birds, insects, and native planting.",
banners:[
      banner04,
      banner05,
      banner06
]
},
{
title:"Flexible, Human Scaled Spaces",
id:'elements39ffdyf3',
Sub:"Built forms are intentionally modest in scale, favouring courtyards, verandahs, shaded thresholds, and semi open spaces that blur indoor outdoor boundaries. Standardised yet adaptable elements like openings, arches, and shaded edges allow homes to evolve with families while keeping construction efficient and repairable.",
banners:[
      banner07,
      banner08,
      banner09
]
},
]

export default function Architectural() {


    return (
         <div className="dody-container">
       <Header />
       <section>

           <div className='biome biome-687'>
               <div
                   className="biome-element biome-element-31088fa biome-element-31088f89 e-flex e-con-boxed e-con e-parent e-lazyloaded animate-section-trigger">
                   <div className="e-con-inner">
                       <div className="biome-element biome-element-204e737 e-con-full e-flex e-con e-child">

                           <div
                               className="biome-element biome-element-8b6c9ce biome-widget biome-widget-elementskit-heading animated ">
                               <div className="biome-widget-container">
                                   <div className="ekit-wid-con">
                                       <div
                                           className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-">
                                           <h1 data-anim="rotate"
                                               className="ekit-heading--title elementskit-section-title animation__char_come gsap-text">
                                               Architectural <span><span>Consideration</span></span> </h1>
                                           <p data-anim="fade-up"
                                               className="attr-h3 attr-text-white title-anim gsap-text">Biome’s
                                               architectural approach begins with the land itself its soil, contours,
                                               wind, water, and memory. Rather than imposing forms, the design grows out
                                               of what already exists, using local materials and time tested
                                               construction techniques that respect both climate and context.</p>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>

               {items.map((item, id) => (
               <div className="biome-element biome-element-03b44c8 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white animate-section-trigger"
                   key={id} id={item.id}>
                   <a href="/contact" target='_blank' className="e-con-inner">
                       <div
                           className="biome-element biome-element-c3ca9d9 e-con-full e-flex e-con e-child section-scroll-animation">

                           <div
                               className="biome-element biome-element-e67a910 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                               <div className="biome-widget-container">
                                   <div className="ekit-wid-con">
                                       <div
                                           className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                           <h2 data-anim="rotate"
                                               className="ekit-heading--title elementskit-section-title  animation__char_come gsap-text ">
                                               {item.title}</h2>
                                       </div>
                                   </div>
                               </div>
                           </div>
                           <div className="biome-element biome-element-f233ff6 e-con-full e-flex e-con e-child">
                               <div className="biome-element biome-element-bf22355 e-con-full e-flex e-con e-child">
                                   <div
                                       className="biome-element biome-element-7637ce7 biome-widget biome-widget-text-editor animated fadeInUp">
                                       <div className="biome-widget-container">
                                           <p data-anim="fade-up" className="title-anim gsap-text">
                                               {item.Sub}
                                           </p>
                                       </div>
                                   </div>
                               </div>

                           </div>

                           {/* {item.id === "elements39ffdyf3" && (
                           <div className="biome-button-wrapper biome-button-wrapper-flex-12">
                               <a className="biome-button biome-button-link biome-size-sm" href="/fieldhouse">
                                   <span className="biome-button-content-wrapper">

                                       <span className="biome-button-text">Explore Our Fieldhouse</span>
                                       <span className="biome-button-icon">
                                           <svg aria-hidden="true" className="e-font-icon-svg e-fas-angle-right"
                                               viewBox="0 0 256 512">
                                               <path
                                                   d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z" />
                                           </svg>
                                       </span>
                                   </span>
                               </a>

                               <a className="biome-button biome-button-link biome-size-sm" href="/masterplan">
                                   <span className="biome-button-content-wrapper">

                                       <span className="biome-button-text">Explore Our Masterplan</span>
                                       <span className="biome-button-icon">
                                           <svg aria-hidden="true" className="e-font-icon-svg e-fas-angle-right"
                                               viewBox="0 0 256 512">
                                               <path
                                                   d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z" />
                                           </svg>
                                       </span>
                                   </span>
                               </a>
                           </div>
                           )} */}
                       </div>
                       <div
                           className="biome-element biome-element-7928e5d e-grid e-con-full e-con e-child section-scroll-animation">
                           {item.banners.map((img, idx) => (
                           <div className="biome-element biome-element-dac90f79">
                               <img className="attachment-full size-full wp-image-122" alt={img} key={idx}
                                   sizes="(max-width: 800px) 100vw, 800px" src={img} />
                           </div>
                           ))}
                       </div>
                   </a>
               </div>))}
           </div>
       </section>
       <Footer />
   </div>
    )}